export default {"src":"/_next/static/media/Fire.00a1dfbe.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};